import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ApiService from "../../api/apiService";
import UserDetail from "./reusable/user-detail-request-item";
import { convertTo12HourPlusDateFormat } from "../../util/helperFunctions";
import styles from "./view-request-detail.css";
import ImagePreviewModal from "./reusable/image-preview-modal";

function CCARRequestDetail({
  handleShowApproversModal,
  setApproversData,
  userDetails,
}) {
  const location = useLocation();

  const [ccarData, setCCARData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [returnUrl, setReturnUrl] = useState("/");
  const [isUserApprover, setUserApprover] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);

  const handleApproveDenyRequest = async (status) => {
    try {
      const response = await ApiService.forms.approveDenyRequest(
        ccarData.form_id,
        ccarData.form_request_id,
        status,
      );

      if (response?.success) {
        window.location.href = "/requests?p=view-approval-list";
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const getCCARRequest = async () => {
      const searchParams = new URLSearchParams(location.search);

      const requestType = searchParams.get("t");
      const requestLinkId = searchParams.get("r");
      const _returnUrl = searchParams.get("r_url");

      setReturnUrl(_returnUrl || "/");

      const response = await ApiService.forms.getFormRequestDetail(
        requestType,
        requestLinkId,
      );

      console.log("CCAR RESPONSE:", response.request);
      console.log("APPROVALS:", response.request?.approval);
      console.log(
        "FIRST LEVEL:",
        response.request?.approval?.first_level_approval,
      );

      if (response?.success) {
        console.log("CCAR DATA:", response.request);
        console.log("FINAL STATUS:", response.request?.final_status);
        console.log("STATUS:", response.request?.status);
        console.log("APPROVAL:", response.request?.approval);

        setCCARData(response.request);
        console.log(response.request.prospecting_images);
        console.log(response.request.prospecting_images.length);
        setApproversData(response.request?.approval);
      }

      setLoading(false);
    };

    getCCARRequest();
  }, [location.search]);
  useEffect(() => {
    if (userDetails && ccarData) {
      const { approval, overall_approval_status, reject_status } = ccarData;

      const { first_level_approval = [], second_level_approval = [] } =
        approval || {};

      const isFirstLevelApprover = first_level_approval.find(
        (approval) => approval.id === userDetails.id,
      );

      const isSecondLevelApprover = second_level_approval.find(
        (approval) => approval.id === userDetails.id,
      );

      if (
        isFirstLevelApprover &&
        !isFirstLevelApprover.has_voted &&
        !overall_approval_status &&
        !reject_status
      ) {
        setUserApprover(true);
      }

      if (
        isSecondLevelApprover &&
        !isSecondLevelApprover.has_voted &&
        !overall_approval_status &&
        !reject_status
      ) {
        setUserApprover(true);
      }
    }
  }, [userDetails, ccarData]);

  if (loading) {
    return (
      <div className="loader--container">
        <div className="loader--"></div>
      </div>
    );
  }

  if (!ccarData) {
    return (
      <div className="request-detail--card">
        <h2>CCAR Request Not Found</h2>
      </div>
    );
  }
  const renderAttachment = (attachment, index) => {
    if (!attachment) return null;

    const cleanUrl = attachment.split("?")[0].toLowerCase();

    const isImage = /\.(png|jpe?g|gif|webp|bmp)$/i.test(cleanUrl);

    const isPdf = /\.pdf$/i.test(cleanUrl);

    if (isImage) {
      return (
        <div className="attachment-item" key={index}>
          <img
            src={attachment}
            alt={`Attachment ${index + 1}`}
            className="ccar-image-preview bh-clickable-image"
            onClick={() => setPreviewImage(attachment)}
          />
        </div>
      );
    }

    if (isPdf) {
      return (
        <div className="attachment-item">
          <div
            className="ccar-pdf-preview bh-clickable-image"
            onClick={() => window.open(attachment, "_blank")}
          >
            <i className="fa fa-file-pdf-o fa-3x" />
            <span>PDF</span>
          </div>
        </div>
      );
    }
    return (
      <div className="attachment-item" key={index}>
        <a
          href={attachment}
          target="_blank"
          rel="noopener noreferrer"
          className="attachment-btn"
        >
          <i className="fa fa-file-o fa-3x" />
          <br />
          Open File
        </a>
      </div>
    );
  };

  return (
    <div className="view-request-detail-container">
      <a href={returnUrl}>
        <div className="go-back">
          <i className="fa fa-arrow-left fa-3x" aria-hidden="true"></i>
          <span>Go Back</span>
        </div>
      </a>

      <div className="request-detail-row">
        <div className="request-detail--card">
          <div className="request-detail-header">
            <h2>Customer Corrective Action Request</h2>
            <span
              className={`status ${
                ccarData?.final_status === "Approved"
                  ? "approved"
                  : ccarData?.final_status === "Rejected"
                  ? "rejected"
                  : "pending"
              }`}
            >
              {ccarData?.final_status || "Pending"}
            </span>
          </div>

          <hr />

          <div className="request-detail-section">
            <h3>Request Information</h3>

            <div className="detail-row">
              <label>Reference Number</label>
              <span>{ccarData?.reference_number}</span>
            </div>

            <div className="detail-row">
              <label>Issued To</label>
              <span>{ccarData?.issued_to}</span>
            </div>

            <div className="detail-row">
              <label>NC Source</label>
              <span>{ccarData?.nc_source}</span>
            </div>

            <div className="detail-row">
              <label>Warehouse</label>
              <span>{ccarData?.warehouse}</span>
            </div>

            <div className="detail-row">
              <label>Date Submitted</label>
              <span>{convertTo12HourPlusDateFormat(ccarData?.createdAt)}</span>
            </div>
          </div>

          <hr />

          <div className="request-detail-section">
            <h3>Corrective Action Details</h3>

            <div className="description-box">{ccarData?.nc_description}</div>
          </div>

          {ccarData?.prospecting_images && (
            <>
              <hr />

              <div className="request-detail-section">
                <h3>Attachments</h3>

                <div className="request-item-attachment-container">
                  {(() => {
                    let attachments = [];

                    try {
                      attachments = JSON.parse(ccarData.prospecting_images);

                      // Handle double-stringified JSON
                      if (typeof attachments === "string") {
                        attachments = JSON.parse(attachments);
                      }

                      if (!Array.isArray(attachments)) {
                        attachments = [attachments];
                      }
                    } catch {
                      attachments = [ccarData.prospecting_images];
                    }

                    attachments.forEach((attachment, index) => {});

                    return attachments.map((attachment, index) =>
                      renderAttachment(attachment, index),
                    );
                  })()}
                </div>
              </div>
            </>
          )}
          {isUserApprover &&
            !ccarData?.overall_approval_status &&
            !ccarData?.reject_status &&
            ccarData?.final_status === "Pending" && (
              <>
                <hr />

                <div className="approver--actions">
                  <button
                    className="action-btn approve-btn"
                    onClick={() => handleApproveDenyRequest(true)}
                  >
                    Approve Request
                  </button>

                  <button
                    className="action-btn deny-btn"
                    onClick={() => handleApproveDenyRequest(false)}
                  >
                    Deny Request
                  </button>
                </div>
              </>
            )}

          <ImagePreviewModal
            image={previewImage}
            onClose={() => setPreviewImage(null)}
          />
        </div>
      </div>
    </div>
  );
}

export default CCARRequestDetail;
